import React, { PureComponent } from 'react';
import cn from 'classnames';
import { Link } from 'react-router-dom';
import { FormGroup, Input, Label } from 'reactstrap';
import { string, func, bool } from 'prop-types';
import { FMessage } from '../../hoc/IntlComponents';

class FlowTrafficback extends PureComponent {
  static propTypes = {
    onChangeTrafficbackUrl: func.isRequired,
    url: string,
    disabled: bool,
  };

  static defaultProps = {
    url: '',
  };

  handleChange = ({ target }) => {
    const url = target.value.trim();
    this.props.onChangeTrafficbackUrl(url);
  };

  render() {
    const { url, disabled } = this.props;

    return (
      <div className="flow-trafficback">
        <FormGroup className="form-group-upper-label">
          <Label for="flow-trafficback-url">Trafficback URL</Label>
          {/* <div>
            <small>
              <FMessage id="flow.form.trafficback.recommendation.p1" />
              <Link to="/faq/tools/tds/setup">
                <FMessage id="flow.form.trafficback.recommendation.p2" />
              </Link>
              <FMessage id="flow.form.trafficback.recommendation.p3" />
            </small>
          </div> */}
          <Input
            type="url"
            id="flow-trafficback-url"
            placeholder="http://example.com"
            onChange={this.handleChange}
            value={url}
            disabled={disabled}
          />
        </FormGroup>
      </div>
    );
  }
}

export default FlowTrafficback;
